<template>
	<v-container fill-height fluid>
		<v-row align="center" justify="space-around" class="text-center">
			<v-col>
				<p class="body-1">Only Gmail Workspace (G-Suite) accounts work with this integration.</p>
				<a :href="redirect" draggable="false" class="my-3">
					<GoogleBtnSvg class="google-btn" />
					<!-- <img src="./assets/btn_google_signin_dark_normal_web@2x.png" draggable="false" /> -->
				</a>
				<p class="body-1">
					Want to connect your personal Gmail account? <br />
					<a href="javascript:window.close()">Close this window</a> and choose "Gmail - Personal" in the actions menu.
				</p>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import GoogleBtnSvg from './assets/GoogleBtnSvg';

export default {
	name: 'PreProfileConnect',
	components: { GoogleBtnSvg },
	props: { redirect: { type: String } },
};
</script>

<style scoped lang="scss">
a {
	display: inline-block;
	position: relative;
	max-width: 280px;
	transition: 0.3s;

	&:hover {
		transition: 0.2s;
		opacity: 0.9;
	}

	&:active {
		top: 1px;
	}

	img {
		width: 100%;
	}

	.google-btn {
		height: 60px;
		margin: 10px 0 0 -44px;
	}
}
</style>
